import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import posthog from 'posthog-js';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import App from "./App.tsx";
import "./index.css";

// PostHog Analytics
// NOTE: If you see 401/404 errors in the console, verify:
// 1. The project exists at https://us.posthog.com (US Cloud)
// 2. The API key below matches the project's key (Project Settings > API Key)
// 3. The hosting platform allows CSP connections to us.i.posthog.com
posthog.init('phc_v6ZTJtYdBGgJ3oz9SZuoMQrWtQy2bSN18SgFF9m6qvo', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: false,
  capture_pageleave: true,
  autocapture: true,
  opt_out_capturing_by_default: true,
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
